import { useSelector } from "react-redux";

const Error = () => {
    const error = useSelector(state => state.error);

    return (
        <div className="min-h-6 mt-2 relative"> {/* 改为最小高度 */}
            {error && (
                <div className="text-red-600 font-semibold text-sm break-words"> {/* 添加文字大小和自动换行 */}
                    {error}
                </div>
            )}
        </div>
    );
}

export default Error;